import store from "@/store";
import Qs from "qs";

const axios = require("axios");

function getHeaders() {
  let headers = { "Content-type": "application/json" };
  if (store.state.auth.jwt) {
    headers["Authorization"] = "Bearer " + store.state.auth.jwt;
  }
  return headers;
}

const SSO_BASE_URL = process.env.VUE_APP_SSO_API_BASE_URL;
const MEMBERS_BASE_URL = process.env.VUE_APP_MEMBERS_API_BASE_URL;
const TRAINING_BASE_URL = process.env.VUE_APP_TRAINING_API_BASE_URL;

class EsepTrainingService {

  /* ---  User services --- */
  getUserInfo(username = null) {
    username = username ?? store.state.auth.username;
    let url = "/user/" + username;
    return axios.get(SSO_BASE_URL + url, { headers: getHeaders() });
  }

  getUsersPermissions(username=null, active=false, unitId=null, permission=null) {
    if (null == username) username = store.state.auth.username;
    let url = "/user/" + username + "/permissions";
    let params = { active: active, unitId: unitId, permission: permission };
    return axios.get(SSO_BASE_URL + url, { headers: getHeaders(), params: params });
  }

  /* ---  Member services --- */
  getAccessibleUnits(memberId) {
    let url = "/member/" + memberId + "/accessible_units";
    return axios.get(MEMBERS_BASE_URL + url, { headers: getHeaders() });
  }

  getMemberById(memberId) {
    let url = `/member/${memberId}` ;
    return axios.get(MEMBERS_BASE_URL + url, { headers: getHeaders() });
  }

  getMembersByCriteria(unitIds, statuses, search = null, yearCensus =null, memberTypes=null,cancelToken=null) {
    let url = "/member";
    let params = {};

    params.search = search;
    params.statuses = statuses;
    params.unitIds = unitIds;
    params.memberTypes = memberTypes;
    params.yearCensus = yearCensus;

    return axios.get(MEMBERS_BASE_URL + url, { cancelToken: cancelToken, headers: getHeaders() , params:  params , paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'}) });
  }

  /* ---  Unit services --- */
  getUnits(status, type) {
    let url = "/unit";
    return axios.get(MEMBERS_BASE_URL + url, { headers: getHeaders(), params: {statuses: status , unitType: type } } );
  }

  /* ---  License services --- */
  getAllLicenses() {
    let url = "/license/titles";
    return axios.get(MEMBERS_BASE_URL + url, { headers: getHeaders() });
  }

  /* ---  Census services --- */
  getCurrentCensusPeriod() {
    let url = "/census/period/current";
    return axios.get(MEMBERS_BASE_URL + url, { headers: getHeaders()});
  } 

  /* ---  Billing Method services --- */
  getBillingMethods() {
    let url = "/billing/method";
    return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()})
  }

  /* --- Activity services --- */
  getActivityById(activityId) {
    let url = "/activity/" + activityId;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  getAnnouncementById(activityId) {
    let url = "/announcement/" + activityId;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  proposeActivity(activity) {
    let url = "/activity/propose";
    console.error(activity);
    return axios.post(TRAINING_BASE_URL + url , activity , {headers : getHeaders() })
  }

  scheduleActivity(activity) {
    let url;
    activity.unit = activity.organizerUnit;
    if (!activity.leader) {
      activity.leader = activity.leaders.find(a => a.position === 'LEADER')?.member;
    }

    if (activity.id) {
      url = `/activity/${activity.id}/schedule`;
      return axios.put(TRAINING_BASE_URL + url , activity , {headers : getHeaders() })
    }
    else{
      url = "/activity/schedule";
      return axios.post(TRAINING_BASE_URL + url , activity , {headers : getHeaders() })
    }
  }

  updateActivity(activity, leaders, periods) {
    let url = `/activity/${activity.id}`;
    return axios.put(TRAINING_BASE_URL + url , {trainingActivity: activity, leaders: leaders, periods: periods} , {headers : getHeaders() });
  }

  changeActivityStatus(activityId, status, comments) {
    let url = `/activity/${activityId}/change_status`;
    return axios.put(TRAINING_BASE_URL + url, {status: status, comments: comments}, {headers: getHeaders()});
  }

  revertActivity(activityId) {
    let url = `/activity/${activityId}/revert`;
    return axios.put(TRAINING_BASE_URL + url, {}, {headers: getHeaders()});
  }

  addPeriod(activityId, period) {
    let url="/activity/"+ activityId +"/period";
    return axios.post(TRAINING_BASE_URL + url , { startDate: period.startDate , endDate: period.endDate , location: period.location} , {headers : getHeaders() });
  }

  deletePeriod(activityId, periodId) {
    let url="/activity/"+ activityId +"/period/" + periodId;
    return axios.delete(TRAINING_BASE_URL + url,  {headers: getHeaders()});
  }

  getActivitysSessions(activityId) {
    let url = "/activity/" + activityId + "/sessions";
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  addSessionToActivity(activityId, sessionId = null, sessionTitle, leaderId=null, associateName=null) {
    let url="/activity/"+ activityId +"/session";
    return axios.post(TRAINING_BASE_URL + url , {sessionId: sessionId , sessionTitle: sessionTitle, leader: { id: leaderId }, associateName: associateName } , {headers : getHeaders() });
  }



  getActivitiesByCriteria(criteria) {
    let url = "/activity";
    // let params = { status: status, search: search, pageNo: pageNo };
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: criteria})
  }

  getActivitysComments(activityId, status) {
    let url = "/activity/wf_steps";
    let params = { status: status, activityId: activityId };
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params})
  }

  downloadActivityWorkbook(activity) {
    let url = `/activity/${activity.id}/workbook`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), responseType: 'blob'});
  }

  /* --- Session Services --- */

  getSessionsByCriteria(moduleId= null, archived= null) {
    let url = "/session";
    let params = { moduleId: moduleId , archived: archived};
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params})
  }

  addSession(session) {
    let url = "/session";
    return axios.post(TRAINING_BASE_URL + url, session, { headers: getHeaders() });
  }

  updateSession(session) {
    let url = `/session/${session.id}`;
    return axios.put(TRAINING_BASE_URL + url, session, { headers: getHeaders() });
  }

  deleteSession( sessionId) {
    let url = `/session/${sessionId}`;
    return axios.delete(TRAINING_BASE_URL + url,  {headers: getHeaders()});
  }

  deleteActivitySession( activityId, sessionId) {

    let url = `/activity/${activityId}/session/${sessionId}`;
    console.warn(url)
    return axios.delete(TRAINING_BASE_URL + url,  {headers: getHeaders()});
  }

  /* --- Trainer Services --- */

  getActivityLeaders(activityId) {
    let url = `/activity/${activityId}/leader`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() })
  }

  getTrainersByModule(moduleId) {
    let url = `/module/${moduleId}/licenses`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() })
  }

  getTrainersByBranch(branch, moduleId=null, position="LEADER") {
    let url = "/trainer";
    let params = { branches: branch, position: position, moduleId: moduleId}
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params })
  }

  getActiveLeaders(search) {
    let url = '/member/active_leaders';
    let params = { search: search}
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), params: params })
  }

  getLeaderDenials(activityId) {
    let url = "/leader/denials";
    let params = { activityId: activityId , statuses: ['ACCEPTED','SUBMITTED']};
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})});
  }

  addLeader(activityId, trainer) {
    let url = `/activity/${activityId}/leader`;
    let params;
    if(trainer.position != 'ASSOCIATE') {
      params = { leader: trainer.member , position: trainer.position , partTime: trainer.partTime , type: trainer.type};
    } else {
      params = { leader: null, associateName: trainer.associateName , position: trainer.position , partTime: trainer.partTime , type: trainer.type};
    }
    return axios.put(TRAINING_BASE_URL + url, params, { headers: getHeaders() });
  }

  deleteLeader(activityId, leaderId) {
    let url = `/activity/${activityId}/leader/${leaderId}`;
    return axios.delete(TRAINING_BASE_URL + url,  {headers: getHeaders()});
  }

  addLeaderDenial(activity, denialReason, memberId) {
    let url = "/leader/denial";
    let denial = {
      activity: activity,
      comments: denialReason,
      member: {id: memberId },
      status: 'SUBMITTED'
    }
    return axios.post(TRAINING_BASE_URL + url, denial, { headers: getHeaders() });
  }

  updateDenialStatus(denialId, status) {
    let url = `/leader/denial/${denialId}`;
    return axios.put(TRAINING_BASE_URL + url, { status: status }, { headers: getHeaders() });
  }

  getLeaderLicensesByCriteria(memberId=null, statuses= null, search=null) {
    let url = `/license`;
    if (search) {
      statuses = null;
    }
    let params = { memberId: memberId, statuses: statuses, search: search}
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), params: params, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})});
  }

  getLeaderLicenseById(licenseId) {
    let url = `/license/${licenseId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  issueLeaderLicense(license, branches, modules) {
    let url = "/license";
    let params = {trainingLicense: license, branches: branches, module: modules}
    return axios.post(TRAINING_BASE_URL + url, params, { headers: getHeaders() })
  }

  updateTrainingLicense(license, branches, modules) {
    let url = `/license/${license.id}`;
    let params = {trainingLicense: license, branches: branches, module: modules}
    return axios.put(TRAINING_BASE_URL + url, params, { headers: getHeaders() })
  }

  downloadLeadersLogbook(member) {
    let url = `/license/${member.id}/logbook/excel`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params:  null, responseType: 'blob'})
  }

  expireLeaderLicense(licenseId, comments, endDate) {
    let url = `/license/${licenseId}/expire`;
    return axios.put(TRAINING_BASE_URL + url, {comment: comments, endDate: endDate}, { headers: getHeaders() })
  }

  /* --- Module Services --- */

  getModulesByCriteria(active, type= null, degree= null) {
    let url = "/module" ;
    let params = {active: active , type: type, degree: degree}
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params });
  }

  getModuleById(moduleId) {
    let url = `/module/${moduleId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders()});
  }

  createModule(module) {
    let url = "/module";
    return axios.post(TRAINING_BASE_URL + url, module, { headers: getHeaders() });
  }

  updateModule(module) {
    let url = `/module/${module.id}`;
    return axios.put(TRAINING_BASE_URL + url , module , {headers : getHeaders() });
  }

  getModuleDependencies(moduleId) {
    let url = `/module/${moduleId}/dependencies`;
    return axios.get(TRAINING_BASE_URL + url, {headers : getHeaders() });
  }

  deleteModuleDependency(moduleId, dependencyId) {
    let url = `/module/${moduleId}/dependencies/${dependencyId}`;
    return axios.delete(TRAINING_BASE_URL + url, {headers: getHeaders() });
  }

  /* --- Announcement Template Services --- */
  createAnnouncement(announcement) {
    let url = "/template";
    return axios.post(TRAINING_BASE_URL + url, announcement, { headers: getHeaders() });
  }

  updateTemplate(template_id) {
    let url = `/template/${template_id.id}`;
    return axios.put(TRAINING_BASE_URL + url , template_id , {headers : getHeaders() });
  }

  getAnnouncementTemplatesByCriteria() {
    let url = "/template" ;
    return axios.get(TRAINING_BASE_URL + url ,{ headers: getHeaders() });
  }

  getTemplateById(template_id) {
    let url = `/template/${template_id}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders()});
  }

  deleteTemplate(template_id) {
    let url = `/template/${template_id.id}`;
    return axios.delete(TRAINING_BASE_URL + url, {headers : getHeaders() });
  }

  /* --- Participation Services --- */

  getParticipations(status, search, unit, memberId=null, participationId=null, includeSubs=false) {
    let url = "/participation";
    let params = {
      statuses: [status],
      search: search,
      unitIds: [unit?.id],
      memberId: memberId,
      participationId: participationId,
      includeSubs: includeSubs
    };
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), params: params, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})});
  }

  getActivitysParticipations(activityId) {
    let url = "/activity/" + activityId + "/participations";
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  updateParticipationStatus(participationId , status , comments = null) {
    let url = "/participation/" + participationId + "/update_status";
    let params = null;
    if(comments == null) {
      params = { status: status };
    } else {
      params = { status: status, comments: comments }
    }
    return axios.put(TRAINING_BASE_URL + url , params , {headers : getHeaders() })
  }

  createParticipation(participation) {
    let url = "/participation";
    return axios.post(TRAINING_BASE_URL + url , participation , {headers : getHeaders() })
  }

  generateRF(activityId, memberId, depositType) {
    let url = "/participation/generate_rf";
    let params = {
      activityId: activityId,
      memberId: memberId,
      depositType: depositType
    };
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params});
  }


  /* --- Accounting Services --- */

  getActivitysAccountingSum(activityId, reportType , recordType = null) {
    let url = `/activity/${activityId}/accounting/sum` ;
    let params = {reportType: reportType , recordType: recordType}
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params });
  }

  getAccountingItems(activityId, recordType) {
    let url = '/accounting/item' ;
    let params = {activityId: activityId , recordType: recordType}
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params });
  }

  addAccountingItem(activityId, categoryId, description, value , reportType ) {
    let url = `/activity/${activityId}/accounting`;
    let params = { activity: { id: activityId } , category: { id: categoryId }, description: description , type: reportType , value: Math.round(value*100) };
    return axios.post(TRAINING_BASE_URL + url , params , {headers : getHeaders() });
  }

  deleteAccountingItem(activityId, itemId) {
    let url = `/activity/${activityId}/accounting/${itemId}`;
    return axios.delete(TRAINING_BASE_URL + url,  {headers: getHeaders()});
  }

  getAccountingCategories() {
    let url = '/accounting/category';
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() })
  }

  /* --- Evaluation Services --- */

  getActivitysEvaluation(activityId) {
    let url = '/evaluation/activity';
    let params  = { activityId: activityId };
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), params: params })
  }

  getSessionsEvaluation(sessionId, activityId) {
    let url = '/evaluation/session';
    let params  = { sessionId: sessionId, activityId: activityId };
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), params: params })
  }

  getActivitysEvaluationAverage(activityId) {
    let url = `/activity/${activityId}/evaluation/items`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() })
  }

  getActivitysEvaluationParticipants(activityId) {
    let url = `/activity/${activityId}/evaluation/participants`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() })
  }

  calculateActivitysEvaluation(activityId) {
    let url = `/activity/${activityId}/evaluation/calculate`;
    return axios.put(TRAINING_BASE_URL + url, null , { headers: getHeaders() });
  }
  
  getActivitysSessionsEvaluation(activityId) {
    let url = `/activity/${activityId}/evaluation/session`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  calculateActivitySessionsEvaluation(activityId,sessionId) {
    let url = `/activity/${activityId}/session/${sessionId}/evaluation/calculate`;
    return axios.put(TRAINING_BASE_URL + url, null , { headers: getHeaders() });
  }

  getSessionsCriteria(sessionId) {
    let url = `/evaluation/criteria/session/${sessionId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  getCriterias(criteriaType , id=null) {
    let url = `/evaluation/criteria/${criteriaType}`;
    let params = null;
    if(criteriaType == 'module') {
      params = { moduleId: id }
    } 
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params });
  }

  getCriteriasCategories() {
    let url = "/evaluation/criteria/category";
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  addCriteria(criteriaType, criteria) {
    let url = `/evaluation/criteria/${criteriaType}`;
    return axios.post(TRAINING_BASE_URL + url , criteria , {headers : getHeaders() });
  }

  updateCriteria(criteriaType, criteria) {
    let url = `/evaluation/criteria/${criteriaType}/${criteria.id}`;
    return axios.put(TRAINING_BASE_URL + url , criteria , {headers : getHeaders() });
  }

  getParticipantEvaluations(memberId) {
    let url = `/evaluation/participation/${memberId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  getTrainerEvaluations(memberId) {
    let url = `/evaluation/leader/${memberId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }


  getMemberProgress(memberId) {
    let url = `/plan/progress/${memberId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  getMemberTrainings(memberId) {
    let url = `/profile/${memberId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders()});
  }

  getParticipation(participationId) {
    let url = `/participation/${participationId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  approveParticipation(participationId, approved, paymentType, depositNo=null, depositComments=null) {
    let url = `/participation/${participationId}/approve`;
    let data = { approve: approved, participation: {paymentType: paymentType, depositNo: depositNo, depositComments: depositComments }}
    return axios.put(TRAINING_BASE_URL + url , data , {headers : getHeaders() })
  }

  cancelParticipation(participationId) {
    let url = `/participation/${participationId}/cancel`;
    return axios.put(TRAINING_BASE_URL + url , {} , {headers : getHeaders() })
  }

  canApproveParticipation(participationId) {
    let url = `/participation/${participationId}/approve`;
    return axios.get(TRAINING_BASE_URL + url , {headers : getHeaders() })
  }

  assignApplyActivity(applyId, member) {
    let url = `/apply-activity/${applyId}/assign`;
    return axios.post(TRAINING_BASE_URL + url , member , {headers : getHeaders() })
  }

  getApplyActivities(memberId=null, validatorId=null, status='IN_PROGRESS') {
    let url = `/apply-activity`;

    let params  = { memberId: memberId, validatorId: validatorId, status: status };

    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), params: params });
  }

  getApplyActivity(applyActivityId) {
    let url = `/apply-activity/${applyActivityId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  uploadApplyFile(applyActivityId, file) {
    let url = `/apply-activity/${applyActivityId}/upload`;

    const formData = new FormData();
    formData.append("file", file);

    return axios.post(TRAINING_BASE_URL + url, formData, { headers: getHeaders(), 'content-type': 'multipart/form-data' })

  }

  getApplyActivityAttachments(applyActivityId) {
    let url = `/apply-activity/${applyActivityId}/attachments`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  deleteApplyFile(applyActivityId, attachmentId) {
    let url = `/apply-activity/${applyActivityId}/delete/${attachmentId}`;
    return axios.delete(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  downloadAttachment(applyActivityId, file) {
    let url = `/apply-activity/${applyActivityId}/download/${file.id}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), responseType: 'blob'});
  }

  completeApplyActivity(applyId) {
    let url = `/apply-activity/${applyId}/complete`;
    return axios.put(TRAINING_BASE_URL + url, {},{ headers: getHeaders() });
  }

  failApplyActivity(applyId) {
    let url = `/apply-activity/${applyId}/fail`;
    return axios.put(TRAINING_BASE_URL + url, {}, { headers: getHeaders() });
  }

  getParticipationByMemberAndActivity(activity_id, memberId) {
    let url = `/participation/activity/${activity_id}`;
    let params = { memberId: memberId }
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params });
  }

  getSessionEvaluation(participationId, sessionId) {
    let url = `/evaluation/participation/${participationId}/session/${sessionId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  updateSessionEvaluationValue(participationId, sessionId, data) {
    let url = `/evaluation/participation/${participationId}/session/${sessionId}`;
    return axios.put(TRAINING_BASE_URL + url, data, { headers: getHeaders() });
  }

  getActivityEvalCriteria(participationId) {
    let url = `/evaluation/participation/${participationId}/activity`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  getActivityEvalInfo(participationId) {
    let url = `/evaluation/participation/${participationId}/info`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  updateActivityEvalCriteria(participationId, data) {
    let url = `/evaluation/participation/${participationId}/activity`;
    return axios.put(TRAINING_BASE_URL + url, data, { headers: getHeaders() });
  }

  getLeaderEvaluationInfo(activityId) {
    let url = `/evaluation/activity/${activityId}/trainer/info`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  getLeaderEvaluation(activityId, leaderId) {
    let url = `/evaluation/activity/${activityId}/trainer/${leaderId}`;
    return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() });
  }

  updateLeaderEvaluationValues(activityId, leaderId, data) {
    let url = `/evaluation/activity/${activityId}/trainer/${leaderId}`;
    return axios.put(TRAINING_BASE_URL + url, data, { headers: getHeaders() });
  }

  batchCreateProfiles(module, memberList) {
    let url = `/profile/batch`;
    let data = {
      module: module,
      members: memberList
    }
    return axios.post(TRAINING_BASE_URL + url, data, { headers: getHeaders() });
  }

  getAnnouncements(criteria, requiresPlan) {
    let url = "/announcement";
    let params = criteria;
    if (requiresPlan) {
      params.requiresPlan = requiresPlan;
    }
    if (!criteria.moduleIds) {
      delete params["moduleIds"];
    }
      return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders(), params: params, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'}) });
  }


}
export default new EsepTrainingService();
